import { useIntl } from "react-intl";

import { STYLE_HOTEL_INPUT } from "../constants";

function ListSelectControl({ field, value, onInput }) {
  const intl = useIntl();
  return (
    <select value={value} onChange={onInput} className={STYLE_HOTEL_INPUT}>
      {field.options.map((option) => (
        <option key={option.value} value={option.value}>
          {intl.formatMessage({ id: option.label })}
        </option>
      ))}
    </select>
  );
}

export default ListSelectControl;
